import { Component, Input } from '@angular/core';
import { Configuration2D } from '../../../../models/configurators-2d/configuration2d';

@Component({
  selector: 'ng-casto-quotation-disabled-products-alert',
  templateUrl: './quotation-disabled-products-alert.component.html',
  styleUrls: ['./quotation-disabled-products-alert.component.scss'],
})
export class QuotationDisabledProductsAlertComponent {
  @Input() configuration: Configuration2D;

  constructor() {}
}
